export default {
  grid: '/admin/coolant-samples',
  data: '/admin/api/coolant-samples',
  export: '/admin/api/coolant-samples/export',
  reportRoute: '/admin/coolant-samples/report',
  reportApi: '/admin/api/coolant-samples/report',
  baselineSampleEndpoint: '/admin/api/coolant-samples/baseline-sample-data',
  individualSample: '/admin/api/coolant-samples/detail',
  addSample: '/admin/api/coolant-samples',
  updateSample: '/admin/api/coolant-samples',
  addEditRoute: '/admin/coolant-samples/detail',
  graphRoute: '/admin/coolant-samples/graph',
  graphApi: '/admin/api/coolant-samples/graph',
  new: '/admin/api/coolant-samples/new',
  deletePrecheck: '/admin/api/coolant-samples/delete-check'
};
